<template>
  <div class="page_tePaymentDtl">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con" v-loading="loading">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item>暂支</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/tePaymentList',query:{
            activeName:activeName
          } }">{{activeName}}</el-breadcrumb-item>
          <el-breadcrumb-item>详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName3" type="card" v-if="type=='approve'">
          <el-tab-pane label="审批内容" name="0"></el-tab-pane>
          <el-tab-pane label="工作流" name="1"></el-tab-pane>
          <el-tab-pane label="流程记录" name="2"></el-tab-pane>
        </el-tabs>
        <div v-if="activeName3=='0'">
          <div v-if="!isNull(baseInfo) && type!='writeOffBatch'">
            <div class="infoBox demandForm">
              <el-form :inline="true" label-width="100px">
                <el-form-item label="暂支编号:">{{baseInfo.advanceNum}}</el-form-item>
                <el-form-item label="OA流程编号:">{{advanceIds ? advanceIds : baseInfo.oanum}}</el-form-item>
                <el-form-item label="暂支申请金额:">￥{{baseInfo.totalFees ? baseInfo.totalFees.toFixed(2) : '0.00'}}</el-form-item>
                <el-form-item label="待核销金额:" v-if="activeName=='待核销'">￥{{baseInfo.tobeWrittenOffAmount ? baseInfo.tobeWrittenOffAmount.toFixed(2) : '0.00'}}</el-form-item>
                <el-form-item label="打款成功金额:" v-if="activeName=='打款成功'">￥{{baseInfo.remittanceAmount}} ￥{{baseInfo.remittanceAmount ? baseInfo.remittanceAmount.toFixed(2) : '0.00'}}</el-form-item>
                <el-form-item label="打款成功时间:" v-if="activeName=='打款成功'">{{ baseInfo.paymentTime ? baseInfo.paymentTime.replace('T',' ') : ''}}</el-form-item>
                <el-form-item label="打款失败金额:" v-if="activeName=='打款失败'"></el-form-item>
                <el-form-item label="打款失败时间:" v-if="activeName=='打款失败'">{{ baseInfo.paymentTime ? baseInfo.paymentTime.replace('T',' ') : ''}}</el-form-item>
                <el-form-item label="费用名称:">{{baseInfo.costName}}</el-form-item>
                <el-form-item label="客户项目:">{{baseInfo.projectName}}</el-form-item>
                <el-form-item label="服务部门:">{{baseInfo.serviceCenterOrCompany}}</el-form-item>
                <el-form-item label="合伙人:">{{baseInfo.applyUserName}}</el-form-item>
                <el-form-item label="暂支人:" v-if="activeName!='待核销'">{{baseInfo.applyUserName}}</el-form-item>
                <el-form-item label="暂支金额:" v-if="activeName=='待核销'"> ￥{{baseInfo.applyFee ? baseInfo.applyFee.toFixed(2) : '0.00'}}</el-form-item>
                <el-form-item label="责任人:">{{baseInfo.personResponsName}}</el-form-item>
                <el-form-item label="暂支人部门:">{{baseInfo.applyDep}}</el-form-item>
                <el-form-item :label="activeName=='待核销' ? '暂支日期' : '申请日期'" v-if="activeName!='待核销'">{{baseInfo.applyTime ? baseInfo.applyTime.split('T')[0]  : ''}}</el-form-item>
                <div class="loongItem">
                  <el-form-item label="申请暂支备注:">{{baseInfo.descFees}}</el-form-item>
                </div>
                <div class="loongItem">
                  <el-form-item label="发票号码:" v-if="invNum">
                    {{invNum}}
                  </el-form-item>
                </div>
                <el-form-item label="申请附件:">
                  <div class="cotName cp" @click="down(baseInfo.fileUrl,baseInfo.fileName)" :title="baseInfo.fileName" v-if="baseInfo.fileUrl">{{baseInfo.fileName}}</div>
                </el-form-item>
                <div class="loongItem">
                  <el-form-item label="打款帐号:" v-if="activeName!='待打款'">{{ baseInfo.payAccount +'/'+baseInfo.payAccountName}}</el-form-item>
                </div>
                <el-form-item label="打款公司:" style="width: 420px">{{ baseInfo.remitAgency }}</el-form-item>
                <div class="loongItem">
                  <el-form-item label="收款帐号:" v-if="activeName!='待打款'">{{baseInfo.receiptAccountName + ' / ' + baseInfo.receiptAccount + ' / ' + baseInfo.depositBank}}</el-form-item>
                </div>
                <div class="loongItem">
                  <el-form-item label="打款备注:" v-if="activeName=='打款成功' || activeName=='打款失败'"></el-form-item>
                </div>
                <div class="loongItem">
                  <el-form-item label="银行流水号:" v-if="activeName=='打款成功' && baseInfo.remitMode!='合作CBS'">
                    <div>
                      <span>{{baseInfo.busNum}}</span>
                      <span class="down cp" style="margin-left:10px">下载回单</span>
                    </div>
                  </el-form-item>
                </div>
                <div class="loongItem">
                  <el-form-item label="合作账号:" v-if="!isNull( baseInfo.cooperatAccount)">{{baseInfo.cooperatAccount+ '/'+baseInfo.cooperatAccountName}}</el-form-item>
                </div>

              </el-form>
            </div>
          </div>

          <div class="verRecBox" v-if="baseInfo.processState=='1' && type
        =='dtl'">
            <div class="Reititle"><span class="titleLine">|</span> 核销记录</div>
            <el-table :data="tableData" border class="doc_table" style="width:800px;margin-top:10px">
              <el-table-column prop="zApplyTime" label="日期" min-width="100" :show-overflow-tooltip="true" align="center">
                <template slot-scope={row}>{{ row.zApplyTime ? row.zApplyTime.split('T')[0] : ''}}</template>
              </el-table-column>
              <el-table-column prop="writtenAmount" label="申请核销金额" min-width="150" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <!-- <el-table-column prop="name" label="审核核销金额" min-width="150" :show-overflow-tooltip="true" align="center">
            </el-table-column> -->
              <el-table-column prop="noTicketCancel" label="核销方式" min-width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="writtenDescrip" label="核销说明" min-width="300" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="name" label="附件" min-width="100" :show-overflow-tooltip="true" align="center">
                <template slot-scope={row}>
                  <span @click="toDownFile(row.fileUrl)" class="blueName cp">{{row.fileName && row.fileUrl ? row.fileName : ''}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div v-if="type=='writeOffBatch'" style="padding-top:20px">
            <div class="flex aic" style="margin-bottom:10px">
              <div class="Reititle"><span class="titleLine">|</span> 报销列表</div>
              <div class="sumAmount">合计待报销金额：￥{{sumBatch}}</div>
            </div>
            <el-table :data="batchList" border class="doc_table" v-loading="loading" style="width:100%" key="writeOff">
              <el-table-column prop="advanceNum" label="暂支编号" min-width="160" :show-overflow-tooltip="true" align="center" fixed="left">
              </el-table-column>
              <el-table-column prop="oanum" label="OA编号" min-width="120" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="remitAgency" label="打款公司" min-width="240" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="costName" label="费用名称" min-width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="typeCost" label="费用类型" min-width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="tobeWrittenOffAmount" label="待核销金额" min-width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="recentlySubmittedAmount" label="最近提交核销金额" min-width="140" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="dateTime" label="最近提交核销时间" min-width="150" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="remittanceAmount" label="打款金额" min-width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="applyCompany" label="申请公司" min-width="150" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="applyDep" label="申请部门" min-width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="applyUserName" label="暂支人" min-width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="personResponsName" label="核销责任人" min-width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="serviceCompany" label="服务公司" min-width="150" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="projectName" label="服务客户项目" min-width="140" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="receiptAccountName" label="收款帐号名称" min-width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="receiptAccount" label="收款帐号" min-width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="depositBank" label="开户银行" min-width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>

              <el-table-column prop="name" label="打款银行" min-width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="name" label="银行流水号" min-width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="name" label="银行回单" min-width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="fileName" label="附件" min-width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="oaApprovalRemarks" label="OA审批备注" :min-width="140" :show-overflow-tooltip="true" align="center">
              </el-table-column>
            </el-table>
          </div>

          <!-- 报销单 -->
          <div class="reimbursementBox" v-if="activeName!='待打款' && activeName!='打款成功' && activeName!='打款失败'">
            <div class="flex aic" style="margin-bottom:10px">
              <div class="Reititle"><span class="titleLine">|</span> 报销单</div>
            </div>
            <div :class="type=='writeOff' ? 'reiTableBox' : 'reiTableBox reiBcg'" v-if="type=='approve' || type=='writeOff' || type=='writeOffBatch'">
              <div class="flex aic reiTableTitle">
                <div>项目名称：{{baseInfo.projectName}}</div>
                <div>部门：{{baseInfo.applyDep}}</div>
                <div class="flex aic">报销日期：
                  <el-date-picker type="date" placeholder="" v-model="reiForm.reimbTime" value-format="yyyy-MM-dd" style="width:130px" size="small"></el-date-picker>
                </div>
              </div>
              <div v-if="type=='writeOff' || type=='writeOffBatch'">
                <el-form>
                  <div style="padding:5px 0 0 40px;">
                    <el-form-item>
                      <el-radio-group v-model="reiForm.noTicketCancel">
                        <el-radio label="有票核销">有票核销</el-radio>
                        <el-radio label="无票核销">无票核销</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                  <div class="colorBox" style="padding:5px 0 5px 57px;background: #F6EBD8">
                    <el-form-item label="核销说明:">
                      <el-input type="textarea" placeholder="" v-model="reiForm.writtenDescrip" :autosize="{ minRows: 2}" style="width:500px">
                      </el-input>
                    </el-form-item>
                    <el-form-item label="材料附件:">
                      <div style="width:300px">
                        <el-upload class="upload-demo" action="" :on-remove="handleRemove" multiple :limit="9" :auto-upload="false" :on-exceed="handleExceed" :on-change="handleUploadM" :file-list="fileList">
                          <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                      </div>
                    </el-form-item>
                  </div>
                </el-form>
              </div>
              <table width="100%" border="0" cellspacing="1" cellpadding="4" class="writeOffTable" align="center">
                <tr>
                  <td width="150px" class="font-center reiTableBox_title">发生日期</td>
                  <td width="150px" class="font-center reiTableBox_title">
                    <span class="required">*</span>报销内容
                  </td>
                  <td width="70px" class="font-center reiTableBox_title">单据张数</td>
                  <td width="100px" class="font-center reiTableBox_title">金额</td>
                  <td width="150px" class="font-center reiTableBox_title">备注</td>
                  <td width="180px" class="font-center reiTableBox_title">发票号码</td>
                  <td width="60px" class="font-center reiTableBox_title">操作</td>
                </tr>
                <tbody v-for="(item,index) in writeOffData" :key="index">
                  <tr v-if="index!=0">
                    <td colspan="6" class="reiTableBox_title">
                      <div class="newPage">新的一页</div>
                    </td>
                  </tr>
                  <tr v-for="(row,i) in item.reiData" :key="i">
                    <td width="150px" class="font-center">
                      <el-date-picker type="date" placeholder="" v-model="row.occurDate" value-format="yyyy-MM-dd" style="width:140px" size="small"></el-date-picker>
                    </td>
                    <td width="150px" class="font-center">
                      <el-select v-model="row.reimbursementContent" placeholder="" clearable filterable style="width:140px" size="small">
                        <el-option v-for="(item,index) in teContList" :key="index" :value="item.name"></el-option>
                      </el-select>
                    </td>
                    <td width="70px" class="font-center">
                      <el-input v-model="row.documentsNum" style="width:60px" size="small"></el-input>
                    </td>
                    <td width="100px" class="font-center">
                      <el-input type="number" v-model="row.amounts" style="width:90px" size="small"></el-input>
                    </td>
                    <td width="150px" class="font-center">
                      <el-input v-model="row.remark" style="width:140px" size="small"></el-input>
                    </td>
                    <td width="180px" class="font-center">
                      <el-input v-model="row.invoiceNum" style="width:140px" size="small" @blur="judgeRepeat(row,index)"></el-input>
                      <i class="el-icon-circle-plus icon01 icon02" @click="addInvoiceNum(row,index)" title="添加多个发票号码"></i>
                    </td>
                    <td width="60px" class="font-center">
                      <div class="injuryTabBtn">
                        <el-button type="text" @click="delLine(item,index,i)" v-if="index == writeOffData.length -1">删除</el-button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="flex reiTableBot">
                <!-- <div class="flex aic cp" @click="addLine">
                  <i class="el-icon-circle-plus icon01"></i>
                  <el-button type="text" style="margin-left:5px">增加行</el-button>
                </div> -->
                <div class="flex aic cp" style="margin-left:30px" @click="addPage">
                  <i class="el-icon-circle-plus icon01"></i>
                  <el-button type="text" style="margin-left:5px">增加一页</el-button>
                </div>
                <el-button type="text" style="margin-left:40px" @click="complete">完成</el-button>
              </div>
            </div>
            <el-button size="small" type="primary" style="margin-left:30px;margin:20px 0" @click="printClick('printBox','')" v-if="activeName=='财务核销'">打印/下载</el-button>
            <div id="printBox" class="printBox">
              <div v-for="(item,index) in rei" :key="index" :class="index%2!=0 && index!=0 ? 'reiItem pb' : 'reiItem'" :id="'reiItem' + index">
                <div :id="'checked' + index" style="margin-bottom:10px" v-if="activeName=='财务核销'">
                  <el-checkbox v-model="item.checked">勾选打印</el-checkbox>
                </div>
                <div class="reiTop flex">
                  <div class="flex aic reiTopleftItem">
                    <div class="qrcode">
                      <img class="cp" :src="imgHead + reiForm.qrcodeUrl" alt="" v-if="reiForm.qrcodeUrl!=undefined && reiForm.qrcodeUrl" @click="showQRcode = true">
                      <img src="./../../assets/images/qrcode.png" alt="" v-else>
                    </div>
                    <div class="reiType" v-if="baseInfo.advanceType!=undefined">{{baseInfo.advanceType.replace('返费','')}}</div>
                  </div>

                  <div class="centerTitle">
                    <div class="reimbursementTitle">报&nbsp;&nbsp;&nbsp;&nbsp;销&nbsp;&nbsp;&nbsp;&nbsp;单</div>
                    <hr width="130px" color="#000" style="margin-top:-1px;border-color:#000" height="1px">
                    <hr width="130px" color="#000" style="margin-top:-5px;border-color:#000">
                  </div>
                  <div class="flex sb aic reiTopRight">
                    <div class="accountBox">
                      <div class="accountName">付款：{{baseInfo.remitAgency}}</div>
                      <div class="accountName">收款：{{type=='writeOffBatch' ? batchList[index].receiptAccountName : baseInfo.receiptAccountName}}</div>
                    </div>
                  </div>
                </div>
                <div class="reiInfo flex sb">
                  <div class="flex">
                    <div>项目名称：</div>
                    <div class="answer">{{type=='writeOffBatch' ? batchList[index].projectName : baseInfo.projectName}}</div>
                  </div>
                  <div class="flex aic reiDate">
                    <!-- <div class="reiRnumber">NO:{{type=='writeOffBatch' ? batchList[index].oanum : baseInfo.oanum}}</div> -->
                    <div class="reiRnumber">NO:{{ item.no!=undefined && item.no ? item.no : baseInfo.oanum}}</div>
                  </div>
                </div>
                <div class="reiInfo flex sb">
                  <div class="flex">
                    <div>部门：</div>
                    <div class="answer">{{baseInfo.applyDep}}</div>
                  </div>
                  <div class="flex aic reiDate">
                    <div class="answer2">{{moment(reiForm.reimbTime).year()}}</div>
                    <div>年</div>
                    <div class="answer2">{{moment(reiForm.reimbTime).month() + 1}}</div>
                    <div>月</div>
                    <div class="answer2">{{moment(reiForm.reimbTime).date()}}</div>
                    <div>日</div>
                  </div>
                </div>
                <table width="100%" border="0" cellspacing="1" cellpadding="4" class="tabtop13" align="center">
                  <tr>
                    <td colspan="2" class="font-center titfont">发生日期</td>
                    <td width="35%" class="font-center titfont" rowspan="2">报销内容</td>
                    <td width="6%" class="font-center titfont" rowspan="2">单据张数</td>
                    <td colspan="9" class="font-center titfont">金额</td>
                    <td class="font-center titfont" rowspan="2">备注</td>
                  </tr>
                  <tr>
                    <td width="5%" class="font-center">月</td>
                    <td width="5%" class="font-center">日</td>
                    <td width="3%" class="font-center">百</td>
                    <td width="3%" class="font-center">十</td>
                    <td width="3%" class="font-center">万</td>
                    <td width="3%" class="font-center">千</td>
                    <td width="3%" class="font-center">百</td>
                    <td width="3%" class="font-center">十</td>
                    <td width="3%" class="font-center">元</td>
                    <td width="3%" class="font-center">角</td>
                    <td width="3%" class="font-center">分</td>
                  </tr>
                  <tr v-for="(row,index) in item.reiData" :key="index">
                    <td class="font-center">{{row.occurDate ? moment(row.occurDate).month() + 1 : ''}}</td>
                    <td class="font-center">{{row.occurDate ? moment(row.occurDate).date() : ''}}</td>
                    <td class="font-center">{{row.reimbursementContent}}</td>
                    <td class="font-center">{{row.documentsNum}}</td>
                    <td class="font-center">{{getNum(row.amounts,'bw')}}</td>
                    <td class="font-center">{{getNum(row.amounts,'sw')}}</td>
                    <td class="font-center">{{getNum(row.amounts,'w')}}</td>
                    <td class="font-center">{{getNum(row.amounts,'q')}}</td>
                    <td class="font-center">{{getNum(row.amounts,'b')}}</td>
                    <td class="font-center">{{getNum(row.amounts,'s')}}</td>
                    <td class="font-center">{{getNum(row.amounts,'g')}}</td>
                    <td class="font-center">{{getNum(row.amounts,'j')}}</td>
                    <td class="font-center">{{getNum(row.amounts,'f')}}</td>
                    <td class="font-center"></td>
                  </tr>
                  <tr>
                    <td colspan="4">合计人民币（大写） {{numberToChinese(item.sum)}}</td>
                    <td class="font-center">{{getNum(item.sum,'bw')}}</td>
                    <td class="font-center">{{getNum(item.sum,'sw')}}</td>
                    <td class="font-center">{{getNum(item.sum,'w')}}</td>
                    <td class="font-center">{{getNum(item.sum,'q')}}</td>
                    <td class="font-center">{{getNum(item.sum,'b')}}</td>
                    <td class="font-center">{{getNum(item.sum,'s')}}</td>
                    <td class="font-center">{{getNum(item.sum,'g')}}</td>
                    <td class="font-center">{{getNum(item.sum,'j')}}</td>
                    <td class="font-center">{{getNum(item.sum,'f')}}</td>
                    <td class="font-center"></td>
                  </tr>
                  <tr>
                    <td colspan="2">主管意见</td>
                    <td colspan="2" class="font-center"></td>
                    <td colspan="9">报销人签章</td>
                    <td class="font-center">{{baseInfo.applyUserName}}</td>
                  </tr>
                </table>
                <div class="flex reiBot">
                  <div>批准：</div>
                  <div class="reiBotInfo"></div>
                  <div>复核：</div>
                  <div class="reiBotInfo"></div>
                  <div>报销人：</div>
                  <div class="reiBotInfo">{{baseInfo.applyUserName}}</div>
                </div>
              </div>
            </div>
          </div>

          <el-form v-if="type=='writeOff' || type=='approve' || type=='writeOffBatch'">
            <el-form-item label="申请核销备注:">
              <el-input type="textarea" placeholder="请输入内容" v-model="reiForm.applyRemark" :autosize="{ minRows: 2}" style="width:500px">
              </el-input>
            </el-form-item>
            <div class="btnBox">
              <el-button @click="goBack">返 回</el-button>
              <!-- <el-button type="primary" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" @click="confirmSave(1)" v-if="type=='writeOff'">仅保存草稿</el-button> -->
              <el-button type="success" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" @click="confirmSave(2)" v-if="activeName=='待核销' && type!='writeOffBatch'" :disabled="isSubmit">提交核销</el-button>
              <el-button type="success" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" @click="confirmSaveBatch" v-if="type=='writeOffBatch'" :disabled="isSubmit">提交核销</el-button>
              <el-button type="danger" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" @click="backHandle" v-if="type=='approve'" :disabled="isSubmit">退 回</el-button>
              <el-button type="success" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" @click="handelApprove('1')" v-if="type=='approve'" :disabled="isSubmit">通 过</el-button>
            </div>
          </el-form>

          <div class="infoTitle incInfo" v-if="type!='writeOffBatch'">OA流程信息
            <el-button type="text" size="small" @click="getMore">
              <i :class="!showMore ? 'el-icon-caret-bottom' : 'el-icon-caret-top'" style="font-size:14px;"></i>
              {{ !showMore ? '展开' : '收起' }}</el-button>
          </div>


          <div v-if="showMore" class="showPaymentInfo">

            <div v-if="!hasMore">
              <table width="1000px" border="0" cellspacing="1" cellpadding="4" class="tabtop15" align="center">
                <tr>
                  <td colspan="4" class="bttit font-center titfont">{{OAinfo.type}}</td>
                </tr>
                <tr>
                  <td width="15%" class="bttit font-center">暂支编号</td>
                  <td width="35%">{{OAinfo.oaNumber}}</td>
                  <td width="15%" class="bttit font-center">申请时间</td>
                  <td width="35%">{{OAinfo.applyTime.replace('0:00:00','')}}</td>
                </tr>
                <tr>
                  <td width="15%" class="bttit font-center">申请公司</td>
                  <td width="35%">{{OAinfo.applyCompanyName}}</td>
                  <td width="15%" class="bttit font-center">申请部门</td>
                  <td width="35%">{{OAinfo.applyDeptName}}</td>
                </tr>
                <tr>
                  <td width="15%" class="bttit font-center">申请人</td>
                  <td width="35%">{{OAinfo.applyUserName}}</td>
                  <td width="15%" class="bttit font-center"></td>
                  <td width="35%"></td>
                </tr>
                <tr>
                  <td width="15%" class="bttit font-center">服务公司</td>
                  <td width="35%">{{OAinfo.serviceCompanyName}}</td>
                  <td width="15%" class="bttit font-center">服务部门</td>
                  <td width="35%">{{OAinfo.serviceDeptName}}</td>
                </tr>
                <tr>
                  <td width="15%" class="bttit font-center">服务客户</td>
                  <td width="35%">{{OAinfo.serviceCustomerName}}</td>
                  <td width="15%" class="bttit font-center">服务中心/分子公司</td>
                  <td width="35%">{{OAinfo.serviceCenterOrCompany}}</td>
                </tr>
                <tr>
                  <td width="15%" class="bttit font-center">费用明细</td>
                  <td width="35%">{{OAinfo.costName}}</td>
                  <td width="15%" class="bttit font-center">费用金额</td>
                  <td width="35%">{{OAinfo.costAmount}}</td>
                </tr>
                <tr>
                  <td width="15%" class="bttit font-center">打款时间</td>
                  <td width="35%">{{OAinfo.paymentTime}}</td>
                  <td width="15%" class="bttit font-center">打款公司</td>
                  <td width="35%">{{OAinfo.remitCompany}}</td>
                </tr>
                <tr>
                  <td width="15%" class="bttit font-center">费用说明</td>
                  <td colspan="3">{{OAinfo.costDesc }}</td>
                </tr>
                <tr>
                  <td width="15%" class="bttit font-center">开户银行</td>
                  <td colspan="3">{{OAinfo.bankName}}</td>
                </tr>
                <tr>
                  <td width="15%" class="bttit font-center">收款人账户名</td>
                  <td colspan="3">{{OAinfo.paymentAccountName}}</td>
                </tr>
                <tr>
                  <td width="15%" class="bttit font-center">银行账号</td>
                  <td colspan="3">{{OAinfo.paymentAccount}}</td>
                </tr>
                <!-- <tr>
                <td width="15%" class="bttit font-center">相关附件</td>
                <td colspan="3">
                  <span @click="toDownFile(OAinfo.fileUrl)" class="blueName cp">{{OAinfo.fileName && OAinfo.fileUrl ? OAinfo.fileName : ''}}</span>
                </td>
              </tr> -->
                <tr v-for="(item,index) in advOaFileList" :key="index">
                  <td width="15%" class="bttit font-center">{{ index == -1 ?'相关附件' : '相关附件' + (index+1)}}</td>
                  <td colspan="3">
                    <span @click="toDownFile(item.oaDownloadurl)" class="blueName cp">{{item.fileName}}</span>
                  </td>
                </tr>
                <tr v-if="advOaFileList.length==0">
                  <td width="15%" class="bttit font-center">相关附件</td>
                  <td colspan="3">
                    <span @click="toDownFile(OAinfo.fileUrl)" class="blueName cp">{{OAinfo.fileName && OAinfo.fileUrl ? OAinfo.fileName : ''}}</span>
                  </td>
                </tr>
                <tr>
                  <td width="15%" class="bttit font-center">核销情况</td>
                  <td width="35%">{{OAinfo.name}}</td>
                  <td width="15%" class="bttit font-center">核销金额</td>
                  <td width="35%">{{OAinfo.name}}</td>
                </tr>
                <tr>
                  <td width="15%" class="bttit font-center">核销说明</td>
                  <td colspan="3">{{OAinfo.remark}}</td>
                </tr>
              </table>
            </div>
            <div v-else>
              <div v-for="(item,index) in OAList" :key="index" style="margin-bottom: 40px">
                <table width="1000px" border="0" cellspacing="1" cellpadding="4" class="tabtop15" align="center">
                  <tr>
                    <td colspan="4" class="bttit font-center titfont">{{item.OAdata.type}}</td>
                  </tr>
                  <tr>
                    <td width="15%" class="bttit font-center">暂支编号</td>
                    <td width="35%">{{item.OAdata.oaNumber}}</td>
                    <td width="15%" class="bttit font-center">申请时间</td>
                    <td width="35%">{{item.OAdata.applyTime.replace('0:00:00','')}}</td>
                  </tr>
                  <tr>
                    <td width="15%" class="bttit font-center">申请公司</td>
                    <td width="35%">{{item.OAdata.applyCompanyName}}</td>
                    <td width="15%" class="bttit font-center">申请部门</td>
                    <td width="35%">{{item.OAdata.applyDeptName}}</td>
                  </tr>
                  <tr>
                    <td width="15%" class="bttit font-center">申请人</td>
                    <td width="35%">{{item.OAdata.applyUserName}}</td>
                    <td width="15%" class="bttit font-center"></td>
                    <td width="35%"></td>
                  </tr>
                  <tr>
                    <td width="15%" class="bttit font-center">服务公司</td>
                    <td width="35%">{{item.OAdata.serviceCompanyName}}</td>
                    <td width="15%" class="bttit font-center">服务部门</td>
                    <td width="35%">{{item.OAdata.serviceDeptName}}</td>
                  </tr>
                  <tr>
                    <td width="15%" class="bttit font-center">服务客户</td>
                    <td width="35%">{{item.OAdata.serviceCustomerName}}</td>
                    <td width="15%" class="bttit font-center">服务中心/分子公司</td>
                    <td width="35%">{{item.OAdata.serviceCenterOrCompany}}</td>
                  </tr>
                  <tr>
                    <td width="15%" class="bttit font-center">费用明细</td>
                    <td width="35%">{{item.OAdata.costName}}</td>
                    <td width="15%" class="bttit font-center">费用金额</td>
                    <td width="35%">{{item.OAdata.costAmount}}</td>
                  </tr>
                  <tr>
                    <td width="15%" class="bttit font-center">打款时间</td>
                    <td width="35%">{{item.OAdata.paymentTime}}</td>
                    <td width="15%" class="bttit font-center">打款公司</td>
                    <td width="35%">{{item.OAdata.remitCompany}}</td>
                  </tr>
                  <tr>
                    <td width="15%" class="bttit font-center">费用说明</td>
                    <td colspan="3">{{item.OAdata.costDesc }}</td>
                  </tr>
                  <tr>
                    <td width="15%" class="bttit font-center">开户银行</td>
                    <td colspan="3">{{item.OAdata.bankName}}</td>
                  </tr>
                  <tr>
                    <td width="15%" class="bttit font-center">收款人账户名</td>
                    <td colspan="3">{{item.OAdata.paymentAccountName}}</td>
                  </tr>
                  <tr>
                    <td width="15%" class="bttit font-center">银行账号</td>
                    <td colspan="3">{{item.OAdata.paymentAccount}}</td>
                  </tr>
                  <!-- <tr>
                <td width="15%" class="bttit font-center">相关附件</td>
                <td colspan="3">
                  <span @click="toDownFile(OAinfo.fileUrl)" class="blueName cp">{{OAinfo.fileName && OAinfo.fileUrl ? OAinfo.fileName : ''}}</span>
                </td>
              </tr> -->
                  <tr v-for="(f,i) in item.advOaFileList" :key="i">
                    <td width="15%" class="bttit font-center">{{ i == -1 ?'相关附件' : '相关附件' + (i+1)}}</td>
                    <td colspan="3">
                      <span @click="toDownFile(f.oaDownloadurl)" class="blueName cp">{{f.fileName}}</span>
                    </td>
                  </tr>
                  <tr v-if="advOaFileList.length==0">
                    <td width="15%" class="bttit font-center">相关附件</td>
                    <td colspan="3">
                      <span @click="toDownFile(item.OAdata.fileUrl)" class="blueName cp">{{item.OAdata.fileName && item.OAdata.fileUrl ? item.OAdata.fileName : ''}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td width="15%" class="bttit font-center">核销情况</td>
                    <td width="35%">{{item.OAdata.name}}</td>
                    <td width="15%" class="bttit font-center">核销金额</td>
                    <td width="35%">{{item.OAdata.name}}</td>
                  </tr>
                  <tr>
                    <td width="15%" class="bttit font-center">核销说明</td>
                    <td colspan="3">{{item.OAdata.remark}}</td>
                  </tr>
                </table>
              </div>
            </div>

          </div>

        </div>
        <div v-if="activeName3=='1' && this.WorkerList.length>0">
          <div style="margin-left:30px">
            <el-steps direction="vertical" :active="WorkerList.length" finish-status="success">
              <el-step v-for="(item,index) in WorkerList" :key="index" :title="item.nodeName" :description="item.title"></el-step>
            </el-steps>
          </div>
        </div>

        <div class="timelineBox" v-if="activeName3=='2'">
          <el-timeline>
            <el-timeline-item placement="top" v-for="(item,index) in WorkerList" :key="index">
              <el-card>
                <p>时间：{{ item.createTime }}</p>
                <p>记录：{{ item.title }} <span v-if="item.remark" style="margin-left: 20px;">备注： {{ item.remark }}</span> </p>
                <p>处理人：{{ item.userName }}</p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>

    </div>

    <el-dialog title="添加发票号码" :visible.sync="showAddInvoiceNum" width="500px">
      <el-form ref="prForm" label-width="80px">
        <el-form-item label="发票号码" v-for="(item,index) in invoiceNumList" :key="index">
          <el-input v-model="item.num" style="width:220px" size="small" @blur="judgeRepeat2(item.num,index)"></el-input>
          <el-button type="text" style="margin-left:10px" @click="delInvoiceNum(index)" v-if="invoiceNumList.length>1">删除</el-button>
        </el-form-item>
        <el-button type="text" @click="addNewInvoiceNum">添加发票号码</el-button>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddInvoiceNum = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmAddInvoiceNum" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog title="退回" :visible.sync="showBack" width="400px">
      <el-form label-width="80px">
        <el-form-item label="退回原因">
          <el-input v-model="ReturnReason" style="width:220px" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showBack = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="handelApprove('0')" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提交成功,是否需要打印/下载" :visible.sync="showReq" width="500px">
      <div class="printTip">提交成功，是否需要打印/下载</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="goBack" size="small">不需要</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="needPrint">打印/下载</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="showQRcode" width="480px">
      <img :src="imgHead + reiForm.qrcodeUrl" alt="" style="width: 300px;height: 300px;margin-left: 50px;">
      <span slot="footer" class="dialog-footer">
        <el-button @click="showQRcode = false" size="small">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import * as math from 'mathjs'
  import print from 'print-js';
  import moment from 'moment';
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          busiId: '',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        },
        writeOffData: [{
          no: '',
          reiData: [{
            occurDate: '', //发生日期
            reimbursementContent: '', //报销内容
            invoiceNum: '', //发票号码
            documentsNum: '', //单据张数
            amounts: '', //金额
            remark: '', //备注
          }]
        }],
        reiForm: {
          Id: '',
          advanceId: '',
          writtenAmount: "", //核销金额
          applyRemark: "", //申请核销备注
          reimbTime: '', //报销日期
          processState: "", //流程状态:部门审核,财务核销,核销完成
          noTicketCancel: "有票核销", //有票核销无票核销
          writtenDescrip: "", //核销说明
          materAcces: [], //材料附件
          reimbContent: [], //报销内容
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        },
        tableData: [],
        writeOffId: null, //核销id
        fileList: [],
        rei: [{
          no: '',
          reiData: [{
            occurDate: '', //发生日期
            reimbursementContent: '', //报销内容
            invoiceNum: '', //发票号码
            documentsNum: '', //单据张数
            amounts: '', //金额
            remark: '', //备注
          }]
        }],
        sumBatch: 0,
        activeName: '',
        baseInfo: {},
        showDropScreen: -1,
        headPath: this.$store.state.EMP.tablePath,
        imgHead: this.$store.state.EMP.imgPath,
        roletype: localStorage.loginRoletype,
        totalcount: 0,
        loading: false,
        showMore: true, //展开OA信息
        type: '',
        isBtnLoading: false,
        isBtnLoading2: false,
        activeName2: 0,
        activeName3: '0',
        WorkerList: [], //工作流
        OAdata: [],
        oanum: [],
        batchList: [], //批量核销列表
        OAinfo: {
          type: ''
        },
        resId: '',
        isSubmit: false,
        teContList: [], //报销内容列表
        showAddInvoiceNum: false,
        advanceIds: '',
        OAList: [],
        hasMore: false,
        invoiceNumList: [{
          num: ''
        }],
        info: {},
        invNum: '',
        showReq: false,
        showQRcode: false,
        showBack: false, //退回弹窗
        ReturnReason: '', //退回原因
      }
    },
    created() {
      if (this.$route.query.type != undefined && this.$route.query.type) {
        this.type = this.$route.query.type;
        this.activeName = this.$route.query.activeName;
        if ((this.type == 'writeOff' || this.type == 'approve' || this.activeName == '部门审核' || this.activeName == '财务核销' || this.activeName == '核销记录' || this.activeName == '核销完毕') && this.$route.query.writeOffId) {
          this.writeOffId = this.$route.query.writeOffId;
          this.GetWriteoffDetail();
        }
        if (this.$route.query.from != undefined && this.$route.query.from == 'staging') {
          this.writeOffId = this.$route.query.Id;
          this.GetWriteoffDetail();
        } else if (this.type == 'approve') {
          this.GetApprovalList();
        } else if (this.type == 'writeOffBatch') {
          this.ids = this.$route.query.id.split(',');
          this.oanum = this.$route.query.oanum.split(',');
          this.listQuery.busiId = this.ids[0];
          this.oanum.forEach((element, index) => {
            this.getBatchList(element, index)
            if (index != 0) {
              this.addPage();
            }
            this.writeOffData[index].no = element;
            if (this.oanum.length - 1 == index) {
              this.complete();
            }
          });
          this.GetAdvancesDetail();
        } else {
          this.listQuery.busiId = this.$route.query.id;
          this.GetAdvancesDetail();
        }
        let now = moment().format('YYYY-MM-DD');
        if (moment(now).date() > 15) {
          this.reiForm.reimbTime = moment().endOf('month').format('YYYY-MM-DD');
        } else {
          this.reiForm.reimbTime = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
        }
      }
      this.getTeContList();
    },
    methods: {
      checkPermission,
      down(url, name) {
        console.log(url, name)
        var path = url;
        const aTag = document.createElement('a')
        aTag.download = name //这里写保存时的名称
        aTag.href = path
        aTag.click();
      },
      //获取报销内容
      getTeContList() {
        let data = {
          parentId: 1
        }
        xz.AdvanceFun(data, 'GetDicList').then(res => {
          if (res.status == 'ok') {
            this.teContList = res.data
          } else {
            this.teContList = [];
          }
        })
      },
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN" ||
          o == '[{}]'
        );
      },
      getMore() {
        this.showMore = !this.showMore
      },
      //打印
      printClick(id, ignoreIds) {
        if (this.isSubmit || this.activeName != '待核销') {
          let arr = [];
          this.rei.forEach((element, index) => {
            let d = 'checked' + index;
            arr.push(d)
            if (!element.checked) {
              let dd = 'reiItem' + index;
              arr.push(dd)
            }
          });
          const style = '.page {margin:0 10mm};' //打印时去掉眉页眉尾
          // let that = this;
          setTimeout(function () {
            printJS({
              printable: id, // 标签元素id
              type: 'html',
              targetStyles: ['*'],
              style: `.page{margin:10px;height:2000px} table{border-collapse:separate} .reiItem{ margin: 100px 0!important;}`,
              ignoreElements: arr,
              // onPrintDialogClose:that.printSuccess()  // 绑定打印成功的回调函数
            });
            // console.log(window.matchMedia('print'))
          }, 500)
        } else {
          this.$message.warning('提交后才能打印')
        }
        //各个配置项
        //printable:要打印的id。
        //type:可以是 html 、pdf、 json 等。
        //properties:是打印json时所需要的数据属性。
        //gridHeaderStyle和gridStyle都是打印json时可选的样式。
        //repeatTableHeader:在打印JSON数据时使用。设置为时false，数据表标题将仅在第一页显示。
        //scanStyles:设置为false时，库将不处理应用于正在打印的html的样式。使用css参数时很有用，此时自己设置的原来想要打印的样式就会失效，在打印预览时可以看到效果
        //targetStyles: [’*’],这样设置继承了页面要打印元素原有的css属性。
        //style:传入自定义样式的字符串，使用在要打印的html页面 也就是纸上的样子。
        //ignoreElements：传入要打印的div中的子元素id，使其不打印。非常好用
      },
      printSuccess() {
        console.log('打印成功哈哈哈')
      },
      GetAdvancesDetail() {
        this.loading = true;
        xz.GetAdvancesDetail(this.listQuery).then(res => {
          try {
            if (res.status == 'ok') {
              this.baseInfo = res.data.adVerifs;
              if (this.type != 'writeOffBatch') {
                this.writeOffData[0].no = this.baseInfo.oanum;
              }
              this.advOaFileList = res.data.advOaFileList;
              this.OAdata = res.data.list;
              if (res.data.list.length > 0) {
                this.showMore = true;
              } else {
                this.showMore = false;
              }
              if (this.OAdata.length > 0 && this.OAdata[0].type != '工作日志') {
                this.OAinfo = this.OAdata[0]
              }
              if (this.type == 'dtl' && this.activeName == '待核销') {
                this.WriteOffList();
              }
              this.loading = false;
            } else {
              this.OAdata = [];
              this.$message.error(res.msg);
              this.loading = false;
            }
          } catch (e) {
            console.log(e)
            this.$message.error('系统出错');
            this.loading = false;
          }
        })
      },
      //上传材料附件
      handleUploadM(file, fileList) {
        console.log(file)
        if (file.size > 10 * 1024 * 1024) {
          this.fileList = [];
          this.$message({
            type: 'warning',
            message: '上传的文件超过10M,请打包压缩后上传',
            duration: 5000
          })
        } else {
          const formData = new FormData();
          formData.append("pagename", "docinf");
          formData.append("action", "save");
          formData.append("userid", Cookies.get("userid-b"));
          formData.append("entid", Cookies.get("userid-b"));
          formData.append("excel", file.raw, file.name);
          console.log("formData", formData);
          xz.uploadCert(formData).then((res) => {
            if (res) {
              this.fileList.push({
                name: file.name,
                url: res,
              });
            } else {
              // this.formData.DetailsUrl = ''
            }
          });
        }
      },
      handleRemove(file) {
        // this.formData.DetailsUrl = ''
      },
      handleExceed() {
        this.$message.warning(`当前限制最多上传 9 个文件`);
      },
      //删除行
      delLine(item, index, i) {
        if (item.reiData.length == 1) {
          this.writeOffData.splice(index, 1);
        } else {
          item.reiData.splice(i, 1);
        }
      },
      addLine() {
        let data = {
          occurDate: '', //发生日期
          reimbursementContent: '', //报销内容
          documentsNum: '', //单据张数
          invoiceNum: '', //发票号码
          amounts: '', //金额
          remark: '', //备注
        }
        if (this.writeOffData[this.writeOffData.length - 1].reiData.length < 6) {
          this.writeOffData[this.writeOffData.length - 1].reiData.push(data);
        } else {
          let d = {
            no: this.baseInfo.oanum,
            reiData: [{
              occurDate: '', //发生日期
              reimbursementContent: '', //报销内容
              documentsNum: '', //单据张数
              invoiceNum: '', //发票号码
              amounts: '', //金额
              remark: '', //备注
            }]
          }
          this.writeOffData.push(d)
        }
      },
      addPage() {
        // let data2 = {
        //   occurDate: '', //发生日期
        //   reimbursementContent: '', //报销内容
        //   documentsNum: '', //单据张数
        //   amounts: '', //金额
        //   remark: '', //备注
        // }
        // let l = this.writeOffData[this.rei.length - 1].reiData.length;
        // for (var j = 0; j < 6 - l; j = j + 1) {
        //   this.writeOffData[this.writeOffData.length - 1].reiData.push(data2)
        // }
        let d = {
          reiData: [{
            occurDate: '', //发生日期
            reimbursementContent: '', //报销内容
            documentsNum: '', //单据张数
            invoiceNum: '', //发票号码
            amounts: '', //金额
            remark: '', //备注
          }]
        }
        this.writeOffData.push(d)
      },
      complete() {
        this.getTotalAmounts();
        setTimeout(() => {
          this.rei = JSON.parse(JSON.stringify(this.writeOffData));
          let data2 = {
            occurDate: '', //发生日期
            reimbursementContent: '', //报销内容
            documentsNum: '', //单据张数
            invoiceNum: '', //发票号码
            amounts: '', //金额
            remark: '', //备注
          }
          this.rei.forEach(element => {
            let l = element.reiData.length;
            this.$set(element, 'checked', true)
            for (var j = 0; j < 6 - l; j = j + 1) {
              element.reiData.push(data2)
            }
          });
        }, 100);
      },
      getNum(num, t) {
        if (num != undefined && num) {
          num = Number(num)
          let result = '';
          let c = '';
          switch (t) {
            case 'j':
              c = num.toFixed(2).split('.')[1]
              result = parseInt((c % 100) / 10)
              break;
            case 'f':
              c = num.toFixed(2).split('.')[1]
              result = parseInt(c % 10)
              break;
            case 'g':
              result = parseInt(num % 10)
              break;
            case 's':
              if (num < 10) {
                result = ''
              } else {
                result = parseInt((num % 100) / 10)
              }
              break;
            case 'b':
              if (num < 100) {
                result = ''
              } else {
                result = parseInt((num % 1000) / 100)
              }
              break;
            case 'q':
              if (num < 1000) {
                result = ''
              } else {
                result = parseInt((num % 10000) / 1000)
              }
              break;
            case 'w':
              if (num < 10000) {
                result = ''
              } else {
                result = parseInt((num % 100000) / 10000)
              }
              break;
            case 'sw':
              if (num < 100000) {
                result = ''
              } else {
                result = parseInt((num % 1000000) / 100000)
              }
              break;
            case 'bw':
              if (num < 1000000) {
                result = ''
              } else {
                result = parseInt((num % 10000000) / 1000000)
              }
              break;
          }
          // let n2 = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
          return result
        }
      },
      //获取每张报销单的总金额
      getTotalAmounts() {
        this.writeOffData.forEach((element, index) => {
          let sum = 0;
          element.reiData.forEach(e => {
            // sum = sum + Number(e.amounts)
            sum = math.format(
              math.add(
                math.bignumber(sum), math.bignumber(Number(e.amounts))
              )
            )
          });
          this.$set(element, 'sum', sum)
          if (index == this.writeOffData.length - 1) {
            setTimeout(() => {
              this.getTotalAmounts2()
            }, 200);
          }
        });
      },
      //获取总金额
      getTotalAmounts2() {
        let sum2 = 0;
        this.rei.forEach(element => {
          // sum2 = sum2 + Number(element.sum)
          sum2 = math.format(
            math.add(
              math.bignumber(sum2), math.bignumber(Number(element.sum))
            )
          )
        });
        this.reiForm.writtenAmount = sum2;
      },
      //返回
      goBack() {
        window.close()
      },
      //保存报销单
      confirmSave(type) {
        this.complete();
        let canSave = true;
        let require = true;
        let require2 = true;
        // let invoiceNum = this.writeOffData[0].reiData[0].invoiceNum
        this.writeOffData.forEach((element, index) => {
          element.reiData.forEach((e, i) => {
            // if (!e.invoiceNum) {
            //   require = false;
            // }
            if (!e.reimbursementContent) {
              require2 = false;
            }
            // if (e.invoiceNum == invoiceNum && index != 0) {
            //   canSave = false;
            // }
            if (index == this.writeOffData.length - 1 && i == element.reiData.length - 1) {
              // if (require && canSave && require2) {
              //   this.confirmSave2(type)
              // } else if (!require) {
              //   this.$message.error('发票号码是必填项！请填写发票号码')
              // } else if (!require2) {
              //   this.$message.error('报销内容是必填项！请选择报销内容')
              // } else if (require && !canSave) {
              //   this.$message.error('填写的发票号码出现重复，请检查')
              // }
              if (!require2) {
                this.$message.error('报销内容是必填项！请选择报销内容');
                this.isBtnLoading = false;
              } else {
                setTimeout(() => {
                  this.confirmSave2(type)
                }, 200);
              }
            }
          });
        });
      },
      confirmSave2(type) {
        this.isBtnLoading = true;
        if (this.fileList.length > 0) {
          this.reiForm.materAcces = this.fileList;
        } else {
          this.reiForm.materAcces = []
        }
        this.reiForm.advanceId = this.listQuery.busiId;
        this.reiForm.reimbContent = this.writeOffData;
        xz.addUpdataAdvanceVerif(this.reiForm).then(res => {
          if (res.status == 'ok') {
            if (type == 1) {
              this.$message.success('保存成功');
              setTimeout(() => {
                this.$router.push({
                  path: "/tePaymentList",
                  query: {
                    activeName: this.activeName
                  }
                })
              }, 1000);
            } else if (type == 2) {
              this.resId = res.data;
              this.writeOffId = res.data;
              this.GetWriteoffDetail();
              this.confirmSubmit();
            }
            this.isBtnLoading = false;
          } else {
            if (type) {
              this.$message.error(res.msg);
            }
            this.isBtnLoading = false;
          }
        })
      },
      //提交核销
      confirmSubmit() {
        this.isBtnLoading = true;
        let data = {
          id: this.resId,
          type: '1', //1.为暂支，2为日志
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype
        }
        xz.SubmitWriteoff(data).then(res => {
          if (res.status == 'ok') {
            setTimeout(() => {
              this.isBtnLoading = false;
              this.isSubmit = true;
              this.showReq = true;
            }, 1000);
          } else {
            this.$message.error(res.msg);
            this.isBtnLoading = false;
          }
        })
      },
      confirmSaveBatch() {
        this.isBtnLoading = true;
        let canSave = true;
        let require = true;
        let require2 = true;
        // let invoiceNum = this.writeOffData[0].reiData[0].invoiceNum
        this.writeOffData.forEach((element, index) => {
          element.reiData.forEach((e, i) => {
            // if (!e.invoiceNum) {
            //   require = false;
            //   console.log(e, require)
            // }
            if (!e.reimbursementContent) {
              require2 = false;
            }
            // if (e.invoiceNum == invoiceNum && index != 0) {
            //   canSave = false;
            // }
            if (index == this.writeOffData.length - 1 && i == element.reiData.length - 1) {
              // if (require && canSave) {
              //   this.confirmSaveBatch2()
              // } else if (!require) {
              //   this.$message.error('发票号码是必填项！请填写发票号码')
              //   this.isBtnLoading = false;
              // } else if (require && !canSave) {
              //   this.$message.error('填写的发票号码出现重复，请检查')
              //   this.isBtnLoading = false;
              // }
              if (!require2) {
                this.$message.error('报销内容是必填项！请选择报销内容');
                this.isBtnLoading = false;
              } else {
                this.confirmSaveBatch2()
              }
            }
          });
        });
      },
      confirmSaveBatch2() {
        // this.complete();
        if (this.fileList.length > 0) {
          this.reiForm.materAcces = this.fileList;
        }
        this.reiForm.advanceId = this.ids.toString();
        this.reiForm.reimbContent = this.writeOffData;
        xz.addUpdataAdvanceVerif(this.reiForm).then(res => {
          if (res.status == 'ok') {
            this.resId = res.data;
            this.confirmSubmit();
            this.isSubmit = true;
            this.isBtnLoading = false;
          } else {
            this.$message.error(res.msg);
            this.isBtnLoading = false;
          }
        })
      },
      //获取暂支报销详情
      GetWriteoffDetail() {
        let data = {
          busiId: this.writeOffId,
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype
        }
        xz.GetWriteoffDetail(data).then(res => {
          if (res.status == 'ok') {
            this.reiForm = res.data;
            this.advanceIds = res.data.advanceIds;
            this.listQuery.busiId = res.data.advanceId;
            if (this.type == 'approve' || (this.$route.query.from != undefined && this.$route.query.from == 'staging')) {
              this.GetAdvancesDetail();
              if (res.data.advanceIdNs) {
                let arr = res.data.advanceIdNs.split(',');
                if (arr.length > 1) {
                  this.hasMore = true;
                  arr.forEach(element => {
                    this.getOAInfo(element)
                  });
                }
              } else {}
            }
            this.$set(this.reiForm, 'userId', Cookies.get("userid-b"));
            this.$set(this.reiForm, 'roleType', localStorage.loginRoletype);
            this.fileList = eval(res.data.materAcces);
            this.writeOffData = eval(res.data.reimbContent)
            let arr = [];
            this.writeOffData.forEach(element => {
              element.reiData.forEach(e => {
                arr.push(e.invoiceNum)
              });
            });
            this.invNum = arr.toString();
            this.complete();
            // this.fileList = res.data.materAcces;
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      //多个合并时 获取多个oa信息
      getOAInfo(id) {
        let data = {
          busiId: id,
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        }
        xz.GetAdvancesDetail(data).then(res => {
          try {
            if (res.status == 'ok') {
              let item = {
                OAdata: res.data.list[0],
                advOaFileList: res.data.advOaFileList
              }
              this.OAList.push(item)
            } else {}
          } catch (e) {
            console.log(e)
            this.$message.error('系统出错');
            this.loading = false;
          }
        })
      },
      //审批
      handelApprove(results) {
        this.isBtnLoading = true;
        let data = {
          type: this.activeName == '部门审核' ? '1' : '2',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
          results,
          remark: this.reiForm.applyRemark,
          busiId: this.writeOffId
        }
        if (results == '0') {
          data.ReturnReason = this.ReturnReason
        }
        xz.VerifiDepartAudit(data).then(res => {
          if (res.status == 'ok') {
            this.$message.success('操作成功！');
            this.isBtnLoading = false;
            this.showBack = false;
            this.isSubmit = true;
            setTimeout(() => {
              this.goBack();
            }, 1000);
          } else {
            this.$message.error(res.msg)
            this.isBtnLoading = false;
          }
        })
      },
      //获取审批流
      GetApprovalList() {
        let data = {
          type: this.activeName == '部门审核' ? '1' : '2',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
          busiId: this.writeOffId
        }
        xz.GetApprovalList(data).then(res => {
          if (res.status == 'ok') {
            this.WorkerList = res.data;
          } else {
            this.WorkerList = [];
            this.$message.error(res.msg)
          }
        })
      },
      //附件
      toDownFile(url) {
        window.open(url, "_blank");
      },
      //数字转中文大写
      numberToChinese(money) {
        // if (num) {
        //   const digitMap = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
        //   const unitMap = ["", "拾", "佰", "仟", "万", "亿"];

        //   let chinese = "";
        //   let unitIndex = 0;

        //   if (num === 0) {
        //     return digitMap[0];
        //   }

        //   while (num > 0) {
        //     const digit = num % 10;
        //     if (digit !== 0 || chinese.length === 0 || chinese[0] !== digitMap[0]) {
        //       chinese = digitMap[digit] + unitMap[unitIndex] + chinese;
        //     }
        //     num = Math.floor(num / 10);
        //     unitIndex++;
        //   }

        //   return chinese.replace(/零(千|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整");
        // }
        // 汉字的数字
        let cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
        // 基本单位
        let cnIntRadice = ['', '拾', '佰', '仟']
        // 对应整数部分扩展单位
        let cnIntUnits = ['', '万', '亿', '兆']
        // 对应小数部分单位
        let cnDecUnits = ['角', '分', '厘', '毫']
        // 整数金额时后面跟的字符
        let cnInteger = '整'
        // 整型完以后的单位
        let cnIntLast = '元'
        // 最大处理的数字
        let maxNum = 999999999999999.9999
        // 金额整数部分
        let integerNum
        // 金额小数部分
        let decimalNum
        // 输出的中文金额字符串
        let chineseStr = ''
        // 分离金额后用的数组，预定义
        let parts
        if (money === '') {
          return ''
        }
        money = parseFloat(money)
        if (money >= maxNum) {
          // 超出最大处理数字
          return ''
        }
        if (money === 0) {
          chineseStr = cnNums[0] + cnIntLast + cnInteger
          return chineseStr
        }
        // 转换为字符串
        money = money.toString()
        if (money.indexOf('.') === -1) {
          integerNum = money
          decimalNum = ''
        } else {
          parts = money.split('.')
          integerNum = parts[0]
          decimalNum = parts[1].substr(0, 4)
        }
        // 获取整型部分转换
        if (parseInt(integerNum, 10) > 0) {
          let zeroCount = 0
          let IntLen = integerNum.length
          for (let i = 0; i < IntLen; i++) {
            let n = integerNum.substr(i, 1)
            let p = IntLen - i - 1
            let q = p / 4
            let m = p % 4
            if (n === '0') {
              zeroCount++
            } else {
              if (zeroCount > 0) {
                chineseStr += cnNums[0]
              }
              // 归零
              zeroCount = 0
              chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
            }
            if (m === 0 && zeroCount < 4) {
              chineseStr += cnIntUnits[q]
            }
          }
          chineseStr += cnIntLast
        }
        // 小数部分
        if (decimalNum !== '') {
          let decLen = decimalNum.length
          for (let i = 0; i < decLen; i++) {
            const n = decimalNum.substr(i, 1)
            if (n !== '0') {
              chineseStr += cnNums[Number(n)] + cnDecUnits[i]
            }
          }
        }
        if (chineseStr === '') {
          chineseStr += cnNums[0] + cnIntLast + cnInteger
        } else if (decimalNum === '') {
          chineseStr += cnInteger
        }
        return chineseStr
      },
      WriteOffList() {
        let data = {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: []
          },
          ProcessState: '',
          advanceNum: this.baseInfo.advanceNum,
          advanceId: this.baseInfo.id,
          BusiType: '1',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        }
        xz.WriteOffList(data).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.writeOffData = [];
            this.tableData.forEach((element, index) => {
              this.writeOffData = this.writeOffData.concat(eval(element.reimbContent))
              if (index == this.tableData.length - 1) {
                this.complete();
              }
            });
          } else {
            this.tableData = [];
          }
        })
      },
      //获取批量核销列表
      getBatchList(oanum, index) {
        let d = {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: [{
              property: "createTime",
              order: 1
            }]
          },
          id: '',
          oanum: oanum, //OA编号
          advanceNum: '', //暂支编号
          busiType: '1', //暂支分类
          applyTime: '', //申请时间
          applyCompany: '', //申请公司
          applyDep: '', //申请部门
          applyDepCode: '',
          applyUserName: '', //申请人
          serviceCompany: '', //服务公司
          projectName: '', //项目
          totalFees: '', //费用金额
          costName: '', //费用名称
          applyFee: '', //申请金额
          personResponsName: '', //责任人
          receiptAccountName: '', //收款账户名
          receiptAccount: '', //收款账户
          depositBank: '', //收款开户行
          remitAgency: '', //打款公司
          descFees: '', ////费用说明
          ApplyTimeEnd: '',
          ApplyTimeStart: '',
          oaApprovalRemarks: '', //OA审批备注
          processState: '1',
          RemittanceAmount: '', //实发金额
          TotalFees: '', //申请金额
          PayResult: '',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        }
        xz.GetAdvancePageList(d).then(res => {
          if (res.status == 'ok') {
            this.batchList.push(res.data.data[0]);
            this.sumBatch = math.format(
              math.add(
                math.bignumber(Number(this.sumBatch)), math.bignumber(Number(res.data.data[0].tobeWrittenOffAmount))
              )
            )
            this.writeOffData[index].reiData[0].amounts = res.data.data[0].tobeWrittenOffAmount;
            console.log(this.writeOffData)
          } else {

          }
        })
      },
      //判断是否重复
      judgeRepeat(row, index) {
        if (row.invoiceNum) {
          xz.GetCheckinvoiceNum(this.writeOffId, row.invoiceNum).then(res => {
            if (res.status == 'ok') {} else {
              this.$set(row, 'invoiceNum', '');
              this.$message({
                type: 'error',
                message: res.msg,
                duration: 5000
              })
            }
          })
        }
      },
      //判断是否重复
      judgeRepeat2(num, index) {
        if (num) {
          xz.GetCheckinvoiceNum(this.writeOffId, num).then(res => {
            if (res.status == 'ok') {} else {
              this.$set(this.invoiceNumList[index], 'num', '');
              this.$message({
                type: 'error',
                message: res.msg,
                duration: 5000
              })
            }
          })
        }
      },
      //添加多个发票号码
      addInvoiceNum(row, index) {
        this.info = row;
        if (row.invoiceNum) {
          let arr = row.invoiceNum.split(',');
          this.invoiceNumList = [];
          arr.forEach(element => {
            let data = {
              num: element
            }
            this.invoiceNumList.push(data)
          });
        } else {
          this.invoiceNumList = [{
            num: ''
          }]
        }
        this.showAddInvoiceNum = true;
      },
      //添加一行发票号码
      addNewInvoiceNum() {
        let data = {
          num: ''
        }
        this.invoiceNumList.push(data)
      },
      delInvoiceNum(index) {
        this.invoiceNumList.splice(index, 1)
      },
      confirmAddInvoiceNum() {
        let arr = [];
        this.invoiceNumList.forEach(element => {
          if (element.num) {
            arr.push(element.num)
          }
        });
        this.$set(this.info, 'invoiceNum', arr.toString());
        this.showAddInvoiceNum = false;
      },
      needPrint() {
        this.showReq = false;
        this.printClick('printBox', '');
        // setTimeout(() => {
        //   this.goBack()
        // }, 1000);
      },
      backHandle() {
        this.showBack = true;
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .showPaymentInfo {
    // width: 1161px;
  }

  .infoBox {
    // width: 1050px;
    background: #E8F7F7;
    padding: 10px 20px;

  }

  .infoTitle {
    font-size: 14px;
    font-weight: 600;
    // text-wrap: nowrap;
    line-height: 32px;
    margin-right: 10px;
  }

  .basicInfo {
    flex-wrap: wrap;
    // width: 900px;
  }

  .infoItem {
    color: #000;
    font-size: 13px;
    min-width: 140px;
    line-height: 32px;
    margin-right: 30px;
  }

  .incInfo {
    margin-top: 10px;
  }

  .readInfo {
    padding: 0 30px;
    display: flex;
    flex-wrap: wrap;
  }

  .readInfoItem {
    width: 240px;
    margin-bottom: 15px;
    font-size: 14px;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .down {
    color: #409EFF;
    margin-right: 15px;
  }

  .showMore {
    width: 1088px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 42px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    text-align: center;
    margin-top: -1px;
    border: 1px solid #ebebeb;
    border-top: 1px solid #eaeefb;
    margin-bottom: 20px;
    font-size: 14px;
  }

  .cotName {
    margin: 0 10px;
    max-width: 5em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #409EFF;
  }

  .verRecBox {
    margin: 20px 0;
  }

  .Reititle {
    font-size: 14px;
    font-weight: bold;
  }

  .titleLine {
    font-size: 16px;
    color: #F59A23;
    margin-right: 3px;
  }

  .reimbursementBox {
    /* color: red; */
    width: 800px;
    color: #000;
    margin: 30px 0;
  }

  .reiTableBox {
    width: 900px;
    padding: 10px 30px 20px 20px;
    // margin: 10px 0 20px;
  }

  .reiBcg {
    background: #FEF8E4;
  }

  .reiTableTitle {
    font-size: 14px;
    justify-content: space-around;
  }

  .reiTableBot {
    justify-content: center;
    font-size: 14px;
  }

  .reiTop {
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
  }

  .reiRnumber {
    font-size: 20px;
    padding-left: 10px;
    font-weight: bold;
  }

  .reimbursementTitle {
    text-align: center;
    font-weight: bold;
    margin-bottom: 3px;
    font-size: 24px;
  }

  .icon01 {
    color: #19bd92;
    font-size: 20px;
    cursor: pointer;
  }

  .icon02 {
    margin-left: 7px;
    margin-top: 3px;
  }

  .centerTitle {
    // width: 300px;
    margin-bottom: 5px;
    font-size: 20px;
  }

  .centerTitle hr {
    margin: 10px auto 0;
  }

  .reiTopRight {
    // width: 300px;
  }

  .accountBox {
    font-size: 14px;
  }

  .qrcode {
    // margin-left: 80px;
    width: 75px;
    height: 70px;
  }

  .qrcode img {
    width: 75px;
    height: 70px;
  }

  .reiInfo {
    font-size: 14px;
    white-space: nowrap;
    margin-top: 10px;
  }

  .answer {
    border-bottom: 1px solid #000;
    padding: 0 15px 3px;
    margin: 0 10px;
    min-width: 100px;
  }

  .answer2 {
    border-bottom: 1px solid #000;
    padding: 0 5px;
    margin: 0 3px;
  }

  .reiDate {
    padding-right: 55px;
  }

  .reiBot {
    font-size: 14px;
    margin-top: 5px;
    font-weight: bold;
    white-space: nowrap;
  }

  .reiBotInfo {
    width: 80px;
  }

  .tabtop13 {
    margin-top: 5px;
  }

  .tabtop13 td {
    background-color: #ffffff;
    height: 30px;
    line-height: 150%;
  }

  .tabtop15 td {
    padding: 8px;
    word-break: break-word;
    font-size: 14px;
  }

  .font-center {
    text-align: center
  }

  .biaoti {
    font-family: 微软雅黑;
    font-size: 26px;
    font-weight: bold;
    border-bottom: 1px dashed #CCCCCC;
  }

  .titfont {
    font-family: 微软雅黑;
    font-size: 16px;
    font-weight: bold;
    // background: url(../images/ico3.gif) no-repeat 15px center;
  }

  .bttit {
    background: #F6F6F6 !important;
  }

  .tabtxt2 {
    font-family: 微软雅黑;
    font-size: 14px;
    font-weight: bold;
    text-align: right;
    padding-right: 10px;
  }

  .tabtxt3 {
    font-family: 微软雅黑;
    font-size: 14px;
    padding-left: 15px;
    color: #000;
    margin-top: 10px;
    margin-bottom: 10px;
    line-height: 20px;
  }

  .printBox table {
    border: #000 2px solid;
    border-collapse: collapse;
  }

  table td,
  table th {
    border: #000 1px solid;
  }

  .showPaymentInfo table td,
  .showPaymentInfo table th {
    border: 1px #d2d2d2 solid;
  }

  .btnBox {
    margin-top: 20px;
    padding: 20px 0 30px 0;
    width: 600px;
    display: flex;
    justify-content: center;
  }

  .reiItem {
    margin: 20px 0;
  }

  .mt {
    // margin-top: 300px;
  }

  .pb {
    page-break-after: always;
  }

  .writeOffTable {
    margin-top: 10px;
    width: 900px;
    background-color: #fff;
    padding: 8px 0;
    line-height: 40px;
  }

  .reiTableBox table td,
  .reiTableBox table th {
    border: #d2d2d2 1px solid !important;
  }

  .reiTableBox table {
    border: #d2d2d2 1px solid !important;
  }

  .reiTableBox_title {
    background: #f6f6f6;
  }

  .newPage {
    text-align: center;
    color: red;
    font-size: 13px;
  }

  .accountName {
    min-width: 100px;
    font-size: 12px;
  }

  .sumAmount {
    margin-left: 50px;
    font-size: 14px;
  }

  .reiType {
    margin-left: 30px;
  }

  .reiTopleftItem {
    min-width: 200px;
  }

  .required {
    color: red;
    margin-right: 3px;
  }

  .printTip {
    font-size: 16px;
  }
</style>
<style>
  .page_tePaymentDtl .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_tePaymentDtl .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_tePaymentDtl .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_tePaymentDtl .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_tePaymentDtl .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_tePaymentDtl .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_tePaymentDtl .demandForm .el-form-item__label {
    color: #999;
  }

  .page_tePaymentDtl .demandForm .el-form--inline .el-form-item {
    width: 270px;
    margin-right: 0;
  }

  .page_tePaymentDtl .demandForm .el-form-item {
    margin-bottom: 0;
  }

  .page_tePaymentDtl .el-form-item {
    margin-bottom: 8px;
  }

  .loongItem .el-form-item {
    width: 100% !important;
  }

  .loongItem .el-form-item__content {
    width: calc(100% - 200px)
  }
</style>